import CheckBox from 'devextreme-react/check-box';
import { LoadIndicator } from 'devextreme-react/load-indicator';

import React, { FC, useState } from 'react';
import classes from '../TodoTable.module.css';
import '../TodoTable.css';
import { ICTask } from '@Helper/Interfaces';
type IProps = {
  task: ICTask;
  updateTaskProperty?: (taskId: string, property: string, value: any) => any;
  showTaskName: boolean;
  disabled?: boolean;
};

const TaskNumberCell: FC<IProps> = ({
  task,
  updateTaskProperty,
  showTaskName,
  disabled,
}) => {
  const [loading, setLoading] = useState<boolean>(false);
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'baseline',
        flexDirection: 'column',
      }}
    >
      {loading ? (
        <LoadIndicator
          height={20}
          width={20}
          style={{ marginRight: 10, position: 'absolute' }}
        />
      ) : (
        <CheckBox
          defaultValue={task.isCompleted}
          value={task.isCompleted}
          disabled={disabled ?? false}
          onValueChange={e => {
            setLoading(true);
            updateTaskProperty &&
              updateTaskProperty(task.id!, 'isCompleted', e).then(() =>
                setLoading(false)
              );
          }}
          className={[
            'custom-table-checkbox',
            task.type === 'milestone' ? 'milestone-task' : null,
          ].join(' ')}
        />
      )}
      {showTaskName && (
        <span
          className={task.isCompleted ? classes.completed : ''}
          style={{ marginLeft: 25 }}
        >
          {task.itemNumber}
        </span>
      )}
    </div>
  );
};

export default TaskNumberCell;
